var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.templates !== null)?_c('v-row',[_vm._l((_vm.templates),function(template){return [_c('v-col',{key:template.template_id,attrs:{"lg":"4","md":"4","sm":"6","xs":"12"}},[_c('SiteTemplateCard',{attrs:{"template":template}})],1)]})],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }